import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Users, ChevronRight } from 'lucide-react';
import { CollapsibleSection } from './IntelligenceUIComponents';

export const TeamBrandImpactSection = ({ data }) => {
  const tbi = data?.teamBrandImpact;
  if (!tbi) return null;
  
  const bte = tbi.brandTransferEffect;
  const pre = tbi.replacementSimulation.preWorldCup;
  const post = tbi.replacementSimulation.postWorldCup;
  const sf = tbi.stabilityFactor;
  const pte = tbi.publicTrustElasticity;
  
  return (
    <CollapsibleSection title="Strategic Impact on Team Brand" icon={Users} defaultOpen={false} badge="Brand Transfer">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="bg-primary/5 border-primary/20">
          <CardContent className="p-5">
            <h3 className="text-xs text-muted-foreground uppercase tracking-wider mb-3">Brand Transfer Effect</h3>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center">
                <span className="text-2xl font-bold text-primary">{bte.influencePercentage}%</span>
              </div>
              <div>
                <p className="text-lg font-semibold">Team Brand Influenced</p>
                <Badge className="bg-primary/20 text-primary">{bte.influenceCategory}</Badge>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">{bte.description}</p>
          </CardContent>
        </Card>

        <div>
          <h3 className="text-xs text-muted-foreground uppercase mb-3">Replacement Simulation</h3>
          <Card className={`mb-3 border-2 ${pre.riskLevel === 'Critical' ? 'border-destructive/30 bg-destructive/5' : 'border-warning/30 bg-warning/5'}`}>
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">{pre.scenario}</span>
                <Badge className="bg-destructive/20 text-destructive">{pre.riskLevel}</Badge>
              </div>
              <p className="text-xl font-bold text-destructive">{pre.projectedBrandImpact} pts</p>
              <p className="text-xs text-muted-foreground">Recovery: {pre.recoveryTimeline}</p>
            </CardContent>
          </Card>
          <Card className="border-border/50 bg-muted/20">
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">{post.scenario}</span>
                <Badge variant="outline">{post.riskLevel}</Badge>
              </div>
              <p className="text-xl font-bold text-warning">{post.projectedBrandImpact} pts</p>
              <p className="text-xs text-muted-foreground">Recovery: {post.recoveryTimeline}</p>
            </CardContent>
          </Card>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div className="p-4 bg-muted/20 rounded-lg">
          <h4 className="text-xs text-muted-foreground uppercase mb-2">Stability Factor</h4>
          <span className="text-2xl font-bold text-stable">{sf.score}</span>
          <Badge className="bg-stable/20 text-stable ml-2">{sf.rating}</Badge>
        </div>
        <div className="p-4 bg-muted/20 rounded-lg">
          <h4 className="text-xs text-muted-foreground uppercase mb-2">Trust Elasticity</h4>
          <p className="text-2xl font-bold">{pte.index}</p>
          <p className="text-xs text-muted-foreground mt-1">{pte.interpretation}</p>
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default TeamBrandImpactSection;
